import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TabuVIPCategory } from "@10x/sso/TabuProfile";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import ContactManager from "@my-dld/components/VIPOwner/ContactManager";
import { OwnerVIPDocument, OwnerVIPRequestStatus, VIPRequest } from "@eres/vipownerapi/entities";
import { getParticipantID } from "@10x/sso";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { VIPOwnerAPI } from "@eres/vipownerapi";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import { DateUtil, StringUtil } from "@eres/core";
import { getVIPRequestStatus, getVIPRequestStatusClass } from "@my-dld/utils/ProcedureUtils";
import { JQModal } from "@my-dld/components/Popup/Utils";
import FullMessagePopup from "@my-dld/components/VIPOwner/FullMessagePopup";
import ManagerDetails from "@my-dld/components/VIPOwner/ManagerDetails";
import ConfirmationPopup from "@my-dld/components/Popup/ConfirmationPopup";
import RequestDocuments from "@my-dld/components/VIPOwner/RequestDocuments";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import VIPRequestsListView from "../../components/MyRequest/VIPRequestsListView";
import VIPRequestsGridView from "../../components/MyRequest/VIPRequestsGridView";
import { getVIPCategory } from "@my-dld/utils/User";
import { formatAppDate } from "@my-dld/utils/Utils";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading?: boolean;
	vipCategory?: TabuVIPCategory;
	vipRequests: VIPRequest[];
	selMessage?: string;
	selRequest?: VIPRequest;
	selDetails?: VIPRequest;
	selRequestDocs?: OwnerVIPDocument[];
}

class AccountManagerInfo extends Component<Props, State> {
	dataView: ListGridDataView<VIPRequest> | null = null;

	constructor( props: Props ) {
		super( props );
		this.state = {
			vipCategory: getVIPCategory(),
			vipRequests: [],
		};
	}

	componentDidMount() {
		this.loadVIPRequests();
	}

	render() {
		const { isLoading, vipCategory, vipRequests, selRequest, selDetails, selMessage, selRequestDocs } = this.state;
		return <React.Fragment>
			<PageContent
				title={ Strings.account_manager_details } hideQLinks={ true }
				sectionClass={ "pt-3 pb-3 property-details" }>
				<PageTitle title={ Strings.account_manager_details } paths={ [ DashboardBCItem ] }/>
				{ vipCategory && <ContactManager
					vipCategory={ vipCategory }
					onNewRequest={ this.loadVIPRequests }/> }
				<FullMessagePopup message={ selMessage }/>
				{ selDetails && <ManagerDetails
					request={ selDetails }
					onDismiss={ () => {
						this.setState( { selDetails: undefined } );
					} }/> }
				{ selRequest && <ConfirmationPopup
					message={ Strings.confirm_cancel_procedure }
					onConfirm={ () => this.onCancelVIPRequest( selRequest ) }
					onCancel={ () => {
						this.setState( { selRequest: undefined } );
					} }/>
				}
				{ selRequestDocs && <RequestDocuments
					documents={ selRequestDocs }
					onDismiss={ () => {
						this.setState( { selRequestDocs: undefined } );
					} }/>
				}
			</PageContent>
			<ListGridDataView
				isLoading={ isLoading }
				dataAvailable={ vipRequests.length > 0 }
				title={ Strings.vip_requests }
				hidePageTitle={ true }
				renderListView={ this.renderListView }
				renderGridView={ this.renderGridView }/>
		</React.Fragment>;
	}

	private renderListView = () => {
		const { vipRequests } = this.state;
		return <VIPRequestsListView
			items={ vipRequests }
			onCancel={ this.onCancel }
			onDocuments={ this.onDocuments }
			onManagerDetails={ this.onManagerDetails }
			onFullMessage={ this.onFullMessage }/>;
	};

	private renderGridView = () => {
		const { vipRequests } = this.state;
		return <VIPRequestsGridView
			items={ vipRequests }
			onCancel={ this.onCancel }
			onDocuments={ this.onDocuments }
			onManagerDetails={ this.onManagerDetails }
			onFullMessage={ this.onFullMessage }/>;
	};

	private onCancel = ( request: VIPRequest ) => {
		this.setState( { selRequest: request } );
	};

	private onFullMessage = ( request: VIPRequest ) => {
		this.setState( { selMessage: request.RequestDescriptionEn }, () => {
			JQModal( "FullMessage" ).show();
		} );
	};

	private onManagerDetails = ( request: VIPRequest ) => {
		this.setState( { selDetails: request }, () => {
			JQModal( "ManagerDetails" ).show();
		} );
	};

	private onDocuments = ( request: VIPRequest ) => {
		this.setState( { selRequestDocs: request.Documents }, () => {
			JQModal( "RequestDocuments" ).show();
		} );
	};

	private loadVIPRequests = () => {
		this.setState( { isLoading: true } );
		VIPOwnerAPI.getVIPOwnerRequests( getParticipantID()! ).then( ( response: any ) => {
			this.setState( {
				isLoading: false,
				vipRequests: response.enquiryResponse ? response.enquiryResponse : [],
			} );
		} ).catch( ( reason ) => {
			this.setState( { isLoading: false } );
			showErrorMessage( reason );
		} );
	};

	private onCancelVIPRequest = ( request: VIPRequest ) => {
		showLoading();
		const reqId = request.OwnerRequestId;
		VIPOwnerAPI.updateVIPOwnerRequest( reqId, OwnerVIPRequestStatus.CANCEL, getParticipantID()! ).then( ( response ) => {
			hideLoading();
			trackEventWithData( "VIPRequest", "CancelSuccess", { requestNumber: "" + reqId } );
			this.setState( {
				vipRequests: this.state.vipRequests!.map( ( req: VIPRequest ) => {
					return ( reqId === req.OwnerRequestId ) ? {
						...req, RequestStatusId: OwnerVIPRequestStatus.CANCEL
					} : req;
				} ),
			} );
		} ).catch( ( reason ) => {
			hideLoading();
			showErrorMessage( reason );
			trackEventWithData( "VIPRequest", "CancelFailed", { requestNumber: "" + reqId } );
		} );
	};
}

export function getVIPReqNo( item: VIPRequest ) {
	return "" + item.OwnerRequestId;
}

export function getVIPReqStatus( item: VIPRequest ) {
	return getVIPRequestStatus( item.RequestStatusId );
}

export function getVIPReqStatusClass( item: VIPRequest ) {
	return getVIPRequestStatusClass( item.RequestStatusId );
}

export function getVIPReqDate( item: VIPRequest ) {
	const date = DateUtil.parseDate( item.RequestDate, "DD/MM/YYYY hh:mm:ss tt" );
	return formatAppDate( date, "en" );
}

export function getVIPReqMessage( item: VIPRequest ) {
	return !StringUtil.isEmptyStringOrNull( item.RequestDescriptionEn ) ? item.RequestDescriptionEn : "";
}

export default AccountManagerInfo;
